import React from 'react';
import SearchInput from '../../../../components/SearchInput';
import useAuth from '../../../../context/AuthContext';

const TabSelection = ({
  tabs,
  setCurrentTab,
  currentTab,
  searchQuery,
  setSearchQuery,
  setOpenSideActionBoard,
}) => {
  const { userData, isEmployee } = useAuth();
  const isAdmin = userData?.roles?.includes('admin');
  const hasAccess = isAdmin || isEmployee;

  return (
    <div className="flex border-b-2 border-gray items-center justify-between mb-6 gap-6 flex-no-wrap">
      <div className="flex items-center gap-6">
        {hasAccess && (
          <ul className="flex items-center p-0">
            {tabs.map((val) => (
              <div
                key={val.label}
                className={`${
                  currentTab?.label === val?.label &&
                  searchQuery === '' &&
                  'border-b-4 border-purple'
                }`}
              >
                <button
                  onClick={() => setCurrentTab(val)}
                  type="button"
                  className={`px-4 py-5 ${
                    currentTab?.label === val?.label &&
                    searchQuery === '' &&
                    'font-semibold'
                  }`}
                >
                  {val.label}
                </button>
              </div>
            ))}
          </ul>
        )}
        {hasAccess && currentTab?.show?.search && (
          <SearchInput
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            active={searchQuery !== ''}
          />
        )}
      </div>
      <div className="flex">
        {hasAccess && (
          <button
            type="button"
            className="flex items-center justify-content-center bg-purple-100 p-2 rounded-lg mr-2 hover:bg-purple-200 whitespace-no-wrap"
            onClick={() =>
              setOpenSideActionBoard({
                type: 'companies',
                action: 'create',
                ids: [],
              })
            }
          >
            Create Company
          </button>
        )}
      </div>
    </div>
  );
};

export default TabSelection;
